import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import * as Styled from './Overlay.styles'
import { Icon, Button } from 'components/atoms'
import React, { useEffect, useState } from 'react'

/**
 * @returns {*}
 * @constructor
 */
const Overlay = ({
  id,
  title,
  iconName,
  children,
  isActive = false,
  showClose = true,
  onToggleActive = () => {},
  variant = 'default',
  onCustomClose = false,
  onCustomApply = false,
}) => {
  const [active, setActive] = useState(isActive)

  useEffect(() => {
    setActive(isActive)
    if (isActive) {
      document.documentElement.classList.add('prevent-scroll')
    } else {
      document.documentElement.classList.remove('prevent-scroll')
    }
  }, [isActive, setActive])

  const onCloseHandler = () => {
    setActive(false)
    document.documentElement.classList.remove('prevent-scroll')
    onToggleActive(false)
  }

  return (
    <>
      {active &&
        ReactDOM.createPortal(
          <Styled.OverlayComponent
            id={ id }
            className='loading-overlay'
            style={{ display: 'block' }}
            data-cy='bookmark-overlay'
            variant={ variant }>
            <div
              onClick={ showClose ? onCloseHandler : null }
              className='overlay-bg-click-area'
            />

            <div className='container-fluid'>
              <div className='overlay-container'>
                <div className='overlay-header'>
                  {iconName && <Icon className={ `${ iconName } overlay-icon` } />}
                  <h5 className='h5 overlay-title'>{title}</h5>
                  {showClose && (
                    <Icon
                      onClick={ onCloseHandler }
                      className='icon-f-cross overlay-close'
                    />
                  )}
                </div>
                <div className='overlay-content' data-cy='overlay-content'>
                  {children}
                </div>
                {variant === 'dialog' && (
                  <div className='dialog-controls'>
                    <Button
                      className='with-border'
                      text='Auswahl zurücksetzen'
                      onClick={
                        onCustomClose ? () => onCustomClose() : undefined
                      }
                    />
                    <Button
                      text='Anwenden & Schließen'
                      onClick={
                        onCustomApply ? () => onCustomApply() : undefined
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          </Styled.OverlayComponent>,
          document.body
        )}
    </>
  )
}

Overlay.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  iconName: PropTypes.string,
  showClose: PropTypes.bool,
  isActive: PropTypes.bool,
  onToggleActive: PropTypes.func,
  variant: PropTypes.oneOf(['default', 'dialog']),
  /** close handle for dialog **/
  onCustomClose: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  /** on apply **/
  onCustomApply: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
}

export default Overlay
